import {guardarDoc} from "../../Servicios/BD/guardarDoc";

export const registrarMovimiento = async ({movimiento, estado}) => {

    movimiento.estado = estado

    let dox = await guardarDoc('movimientos', movimiento)
    if (dox.res) {
        return dox.data
    } else {
        return false
    }


}